<div class="spinner-wrapper">
    <cx-spinner></cx-spinner>
  </div>